import { ConsultingData } from 'constants/AiConsulting/consultingData'
import { FC } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import clsx from 'clsx'

interface ConsultingServiceProps {
  className?: string
  data: ConsultingData
  sectionTitle: string | JSX.Element
  sectionDescription: string | JSX.Element
  columns?: number
  theme?: 'dark' | 'light'
  cardRow?: boolean
  showIconBg?: boolean
  padding20?: boolean
}

const AiBenefits: FC<ConsultingServiceProps> = ({
  className,
  data,
  sectionTitle,
  sectionDescription,
  columns = 4,
  theme = 'dark',
  cardRow = true,
  showIconBg = true,
  padding20 = false,
}) => {
  const getColClass = () => {
    if (columns === 3) return 'col-xl-4 col-md-6 col-12'
    if (columns === 4) return 'col-xl-3 col-md-6 col-12'
    return 'col-xl-4 col-lg-4 col-md-6 col-12'
  }

  return (
    <section
      className={clsx(
        'industries-section benifit-bottom',
        theme === 'dark' ? 'theme-dark bg-black' : 'theme-light bg-gray1',
        className
      )}
    >
      <div className="container">
        <div className="row align-items-center mb-md-5 mb-3">
          {sectionTitle}
          {sectionDescription}
        </div>

        <div className="row justify-content-center">
          {data.services.map((service, index) => {
            const Icon = service.icon

            return (
              <div
                key={index}
                className={`${getColClass()} mb-md-4 mb-3 d-flex justify-content-center `}
              >
                <div
                  className={clsx(
                    'AiBenefitscard d-flex flex-lg-column',
                    cardRow
                      ? 'flex-row gap-lg-0 gap-3 align-items-center align-items-md-start'
                      : 'flex-column',
                    padding20 && 'p-20'
                  )}
                >
                  <div
                    className={clsx(
                      showIconBg && theme === 'light'
                        ? 'gray-bg'
                        : 'p-0 icon-new-size',
                      cardRow ? 'mb-sm-3' : 'mb-3',
                      typeof Icon === 'string' || typeof Icon === 'number'
                        ? null
                        : 'icon'
                    )}
                  >
                    {Icon ? (
                      typeof Icon === 'string' || typeof Icon === 'number' ? (
                        <span
                          className={clsx(
                            columns === 4 ? 'icon-30' : 'icon-34',
                            'ai-benefits-number'
                          )}
                        >
                          {Icon}
                        </span>
                      ) : (
                        <Icon
                          className={`${columns === 4 ? 'icon-30' : 'icon-34'}`}
                        />
                      )
                    ) : null}
                  </div>
                <div>
                  <h3 className="card-title mt-auto">{service.title}</h3>
                  <p className="card-content mb-0">{service.description}</p>
                </div>
              </div>
            </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default AiBenefits
